import React from 'react';

const Copy = (props: { className: any, onClick?: any }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (

    <svg id="Layer_2" className={className} onClick={handleOnClick} data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
      <rect className="cls-1" x="1" y="1" width="16.6" height="16.6" rx="4" ry="4" />
      <rect className="cls-2" x="4.9" y="4.9" width="16.6" height="16.6" rx="3" ry="3" />
    </svg>
  );
};
export default Copy;